import React, { useState } from 'react';
import { faqs } from '../mock';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  return (
    <section className="faq-section" id="faq">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Frequently Asked Questions</span>
          <h2 className="section-title">
            Common Questions About
            <span className="title-highlight"> Trademark Registration</span>
          </h2>
          <p className="section-description">
            Get answers to the most common questions about trademark registration, 
            the USPTO process, costs, and protecting your brand. Still have questions? 
            Our team is here to help.
          </p>
        </div>

        <div className="faq-container">
          <Accordion type="single" collapsible className="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="faq-item">
                <AccordionTrigger className="faq-question">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="faq-answer">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="faq-footer">
          <div className="faq-footer-content">
            <h3 className="faq-footer-title">Still Have Questions?</h3>
            <p className="faq-footer-text">
              Our trademark specialists are available to answer any questions about 
              the registration process, pricing, or your specific trademark needs.
            </p>
            <div className="faq-contact-options">
              <a href="tel:+11231234567" className="faq-contact-button">
                Call: +1 (123) 123-4567
              </a>
              <a href="mailto:info@trademarktexticon.com" className="faq-contact-button">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
